import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetUserByUserTokenAsyncQuery } from "../../api/userAPI";
import AnimatedBackground from "../../components/AnimatedBackground/AnimatedBackground";
import Button from "../../components/Button/Button";
import Form from "../../components/Form/Form";
import { ValidatorsE } from "../../components/Form/yupValidations";
import Loader from "../../components/Loader/Loader";
import { H1 } from "../../components/Text/Text";
import { FormFieldT } from "../../models/models";
import { useResetUserPasswordMutation } from "../../api/loginAPI";
import { toast } from "react-toastify";
import { useTranslate } from "../../utils/hooks/useTranslate";

import styles from "./styles.module.scss";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslate();
  const userId = searchParams.get("userId");
  const Code = searchParams.get("code");
  const { data, isLoading } = useGetUserByUserTokenAsyncQuery({
    userId,
    token: encodeURIComponent(Code),
  });
  const [resetUserPassword, { isLoading: isResettingUserPassword }] =
    useResetUserPasswordMutation();

  const fields: FormFieldT[] = useMemo(
    () =>
      isLoading || !data
        ? []
        : [
            {
              label: "UserName",
              name: "UserName",
              defaultValue: data?.UserName || "",
              validation: ValidatorsE.REQUIRED_STRING,
            },
            {
              label: "New password",
              name: "Password",
              // type: 'password',
              validation: ValidatorsE.PASSWORD,
              // props: {
              //     autocomplete: 'off'
              // }
            },
            {
              label: "Confirm new password",
              name: "ConfirmPassword",
              // type: 'password',
              validation: ValidatorsE.PASSWORD_CONFIRM,
            },
          ],
    [data, isLoading]
  );

  const handleSubmit = async ({ UserName, Password, ConfirmPassword }: any) => {
    const body: any = { Code, UserName, Password, ConfirmPassword };

    try {
      const response = await resetUserPassword(body);
      if ("data" in response) {
        toast(t`Password changed successfully`);
      } else {
        toast.error(t`Something went wrong`);
      }
    } catch (e) {
      toast.error(t`Something went wrong`);
      console.log(e);
    }
  };

  return (
    <main className={styles.mainWrapper}>
      <AnimatedBackground />
      <div className={styles.resetPasswordFormWrapper}>
        <H1>Reset Password</H1>
        {isLoading ? (
          <div>
            <Loader />
          </div>
        ) : (
          <Form
            fields={fields}
            formID="reset-password"
            onSubmit={handleSubmit}
            columns={1}
          />
        )}
        <Button
          form="reset-password"
          loading={isResettingUserPassword}
          disabled={isResettingUserPassword}
        >
          Reset password
        </Button>
      </div>
    </main>
  );
};

export default ResetPassword;
